import { createAction, props } from "@ngrx/store";
import {
  RoomStreamAudioUpdateCmd,
  RoomStreamDeleteCmd,
  RoomStreamRestartCmd
} from "@youm-front/room/domain";

export const roomStreamAudioUpdateEvent = createAction(
  "[Room] Room Stream Audio Update Event",
  props<{ roomStreamAudioUpdateCmd: RoomStreamAudioUpdateCmd }>()
);

export const roomStreamDeleteEvent = createAction(
  "[Room] Room Stream Delete Event",
  props<{ roomStreamDeleteCmd: RoomStreamDeleteCmd }>()
);

export const roomStreamRestartEvent = createAction(
  "[Room] Room Stream Restart Event",
  props<{ roomStreamRestartCmd: RoomStreamRestartCmd }>()
);
